var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    d: "M12.5.5c6.617 0 12 5.383 12 12s-5.383 12-12 12-12-5.383-12-12 5.383-12 12-12m3 5h-6a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-6a4 4 0 0 0-4-4m-.235 1.235a3 3 0 0 1 3 3v5.53l-.005.176a3 3 0 0 1-2.995 2.824h-5.53l-.176-.005a3 3 0 0 1-2.824-2.995v-5.53l.005-.176a3 3 0 0 1 2.995-2.824zm-2.97 2.47a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 1.236a2.265 2.265 0 1 1 0 4.53 2.265 2.265 0 0 1 0-4.53m3.91-2.47a.824.824 0 1 0 0 1.647.824.824 0 0 0 0-1.647"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h24v24H.5z"
  })))));
};
export default SvgInstagram;